import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const tableExpandableRowAnimation = trigger('detailExpand', [
  state('collapsed,void', style({ height: '0px', minHeight: '0' })),
  state('expanded', style({ height: '*' })),
  transition(
    'expanded <=> collapsed',
    animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
  ),
]);

export const expandLeftAnimation = trigger('expandLeft', [
  state('collapsed,void', style({ width: '0px', minWidth: '0', padding: 0 })),
  state('expanded', style({ height: '*' })),
  transition(
    'expanded <=> collapsed',
    animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
  ),
]);
